import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';
import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';

interface Iprops {
  config: PAYMENT_CONFIG.IProcessorConfiguration;
  control: Control<FieldValues, any>;
  marginBottom?: boolean;
  value?: string | null;
  onChange?: (value: string) => void;
  disabled?: boolean;
}
const ConfigToggle = ({
  config,
  control,
  marginBottom,
  value,
  onChange,
  disabled,
}: Iprops) => {
  return (
    <>
      <div
        className={`max-w-3xl flex justify-between ${marginBottom ? 'mb-3' : 'mb-1'}`}
      >
        <span className="mb-3">
          <Label
            htmlFor={config.code}
            className="text-base font-semibold text-gray-blue-80"
          >
            {config.displayName}
          </Label>
          {config.description && (
            <p className="text-sm font-normal leading-5 text-gray-blue-70">
              {config.description}
            </p>
          )}
          {config.helpText && (
            <p className="text-sm font-normal leading-5 text-gray-blue-70">
              <span className="font-semibold">Note: </span>
              {config.helpText}
            </p>
          )}
        </span>
        <span className="mt-1">
          <Controller
            name={config.code}
            control={control}
            rules={{ required: config?.isRequired }}
            render={({ field }) => (
              <Switch
                id={config.code}
                disabled={disabled}
                checked={value ? value === 'true' : field.value === 'true'}
                onCheckedChange={(checked) => {
                  const newValue = checked ? 'true' : 'false';
                  if (onChange) {
                    onChange(newValue);
                  } else {
                    field.onChange(newValue);
                  }
                }}
              />
            )}
          />
        </span>
      </div>
    </>
  );
};

export default ConfigToggle;
